<div class="d-flex popup-container">
  <button class="btn btn-link arrow next" (click)="handleNext()">
    <i class="bi bi-chevron-right"></i>
  </button>
  <div class="column left-column d-flex flex-column align-items-center">
    <div class="flex-grow-1 d-flex align-items-center">
      <img
        src="logo-step-a.png"
        alt="Cashback Illustration"
        class="side-logo"
      />
    </div>
    <div class="d-flex flex-row gap-1 align-items-center">
      <small>Powered by</small>
      <img src="quidco.png" alt="Quido" class="powered-by-logo" />
    </div>
  </div>
  <div class="column right-column">
    <div class="mb-5">
      <h4 class="font-weight-bold">Secure your cashback</h4>
      <p>
        To provide more control over your purchase and cashback bonus we are
        introducing new email relay.
      </p>
    </div>
    <div>
      <h5 class="font-weight-bold">Your benefits</h5>
      <ul>
        <li>Track your cashback and rewards more easily</li>
        <li>No more issues with cashback return due to blocked cookies</li>
        <li>More privacy</li>
      </ul>
    </div>
  </div>
</div>
